import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { AreasExplorer as Areas } from "@/components/site/AreasExplorer";
import { WhyUs } from "@/components/site/WhyUs";
import { LawyerProfile as Lawyer } from "@/components/site/LawyerProfile";
import { Method } from "@/components/site/Method";
import { Booking } from "@/components/site/Booking";
import { Contacts } from "@/components/site/Contacts";
import { Footer, FloatingWhatsapp } from "@/components/site/Footer";
import { ChatWidget } from "@/components/site/ChatWidget";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Areas />
        <WhyUs />
        <Lawyer />
        <Method />
        <Booking />
        <Contacts />
      </main>
      <Footer />
      <FloatingWhatsapp />
      <ChatWidget />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
